export default {
	title: "Rituales",
	notFinished: "No finalizado",
	edit: "Editar Ritual",
	loading: "Cargando ritual...",
	create: "Crear Ritual",
	createdBy: "Creado por",
	dateTime: "Fecha y Horario",
	deleteConfirmation: "¿Desea realmente eliminar el ritual {title}?",
	confirmStatusChange: "Confirmar Cambio de Estado",
	statusChangeConfirmation: "¿Está seguro de que desea cambiar el estado del ritual '{title}' a {status}?",
	notFound: "Ritual no encontrado",
	actions: {
		cancel: "Cancelar",
		complete: "Finalizar",
		delete: "Eliminar",
		start: "Iniciar",
	},
	confirmations: {
		cancel: "¿Está seguro de que desea cancelar este ritual? Esta acción no se puede deshacer.",
		complete: "¿Está seguro de que desea finalizar este ritual?",
		delete: "¿Está seguro de que desea eliminar el ritual '{title}'? Esta acción no se puede deshacer.",
		start: "¿Está seguro de que desea iniciar este ritual?",
	},
	empty: {
		button: "Crear Ritual",
		dependencyWarning: "Para crear rituales, es necesario registrar tipos de atención y tipos de rituales primero.",
		subtitle: "Cree el primer ritual del sistema",
		title: "Ningún ritual encontrado",
	},
	form: {
		startDateLabel: "Fecha y Hora de Inicio",
		endDateLabel: "Fecha y Hora de Cierre",
		dateLabel: "Fecha",
		startTimeLabel: "Hora de Inicio",
		dateHint: "Fecha en que se realizará el ritual",
		descriptionHint: "Descripción detallada del ritual",
		descriptionLabel: "Descripción",
		locationHint: "Lugar donde se realizará el ritual",
		isPublicLabel: "Publicar en la agenda pública",
		isPublicHint: "Hace visible este ritual en la página pública del templo",
		acceptsReservationsLabel: "Aceptar reservas",
		acceptsReservationsHint: "Permite que las personas reserven un lugar para este ritual",
		publicNotesLabel: "Notas públicas",
		publicNotesHint: "Texto mostrado en la agenda pública (opcional)",
		locationLabel: "Lugar",
		ritualTypeHint: "Seleccione el tipo de ritual",
		ritualTypeLabel: "Tipo de Ritual",
		startTimeHint: "Horario de inicio del ritual (obligatorio)",
		statusHint: "Estado actual del ritual",
		statusLabel: "Estado",
		titleHint: "Título que identifica el ritual",
		titleLabel: "Título del Ritual",
		retroactiveWarning:
			"Fecha en el pasado: este ritual se creará como registro retroactivo. Nace como Programado — registre las fichas y use \"Cerrar Ritual\" para registrarlo, sin necesidad de iniciarlo.",
	},
	retroactive: {
		badge: "Registro retroactivo",
	},
	tabs: {
		tickets: "Fichas de Atención",
		stats: "Estadísticas",
		details: "Detalles",
		report: "Informe",
		messages: "Mensajes",
		returns: "Retornos",
	},
	lists: {
		pdf: "PDF",
		xlsx: "XLSX",
		sortCreated: "Orden de creación",
		sortTarget: "Orden de destino",
		sortAlpha: "Orden alfabético",
		messagesEmpty: "Ningún mensaje registrado en este ritual",
		returnsEmpty: "Ningún retorno vinculado a este ritual",
		groupEmpty: "Ningún retorno en este grupo",
		createdHere: "Creados en este ritual",
		fulfilledHere: "Cumplidos en este ritual",
		markedHere: "Marcados para este ritual",
		createdBy: "Creado por",
	},
	status: {
		label: "Estado",
		scheduled: "Programado",
		inProgress: "En Curso",
		in_progress: "En Curso",
		completed: "Completado",
		cancelled: "Cancelado",
		closed: "Cerrado",
	},
	details: {
		ritualType: "Tipo de Ritual",
		noTicketsDescription: "No hay fichas de atención registradas para este ritual",
	},
	deleteWarning: "Todas las fichas, retornos y mensajes vinculados a este ritual serán eliminados permanentemente.",
	deleteCodeInstruction: "Para confirmar, escriba el código {code}:",
	startWarning: "Al iniciar el ritual, las fichas podrán ser distribuidas y llamadas.",
	startCodeInstruction: "Para confirmar, escriba el código {code}:",
	filters: {
		search: "Buscar rituales...",
		date: "Fecha",
		today: "Hoy",
		thisWeek: "Esta semana",
		thisMonth: "Este mes",
		dateFrom: "Fecha inicial",
		dateTo: "Fecha final",
		status: "Estado",
		ritualType: "Tipo de Ritual",
	},
	messages: {
		cancelDisabled: "Rituales cancelados o completados no pueden ser cancelados",
		createError: "Error al crear ritual",
		created: "Ritual '{title}' creado con éxito",
		deleteDisabled: "Rituales cancelados, en curso o completados no pueden ser eliminados",
		deleteError: "Error al eliminar ritual",
		deleted: "Ritual '{title}' eliminado con éxito",
		editDisabled: "Rituales completados o cancelados no pueden ser editados",
		loadError: "Error al cargar rituales",
		startDisabled: "Solo rituales programados pueden ser iniciados",
		statusUpdateError: "Error al actualizar estado del ritual",
		statusUpdated: "Estado del ritual '{title}' cambiado a {status}",
		updateError: "Error al actualizar ritual",
		updated: "Ritual '{title}' actualizado con éxito",
	},
	stats: {
		total: "Total",
		acceptableLimit: "Límite (15 min)",
		attendanceTime: "Tiempo de Atención por Mesa",
		avgTime: "Tiempo medio",
		cancelled: "Cancelados",
		completed: "Completados",
		inProgress: "En Curso",
		loadError: "Error al cargar estadísticas",
		minutes: "minutos",
		noTickets: "Ninguna ficha registrada para este ritual",
		noTicketsSubtitle: "Las estadísticas aparecerán cuando se distribuyan fichas",
		pending: "Pendientes",
		perCardBreakdown: "Fichas por Mesa de Atención",
		scheduled: "Programados",
		statusDistribution: "Distribución por Estado",
		tickets: "fichas",
	},
	table: {
		headers: {
			title: "Título",
			public: "Público",
		},
		public: {
			yes: "En la agenda pública",
			no: "No publicado",
		},
		title: "Título",
	},
	validation: {
		activeRitualExists: "Ya existe un ritual en curso. Solo un ritual puede estar activo a la vez.",
		dateRequired: "La fecha es obligatoria",
		descriptionMaxLength: "La descripción debe tener máximo 500 caracteres",
		publicNotesMaxLength: "Las notas públicas deben tener máximo 500 caracteres",
		invalidTime: "Formato de horario inválido",
		locationMaxLength: "El lugar debe tener máximo 200 caracteres",
		ritualTypeRequired: "El tipo de ritual es obligatorio",
		startTimeRequired: "El horario de inicio es obligatorio",
		statusRequired: "El estado es obligatorio",
		titleMaxLength: "El título debe tener máximo 100 caracteres",
		titleRequired: "El título es obligatorio",
	},
};
